/* Insphirea B2B order page. Tier maths, the first question and its spread, world stills, the receipt,
   share link, native contact form payload. Prices and availability come from the section's JSON;
   nothing is read from Shopify prices or inventory. Strings come from window.INS_B2B_I18N. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ins-b2b]');
  if (!root) return;
  var D = JSON.parse(root.querySelector('[data-ins-b2b-data]').textContent);
  var MOCK = root.getAttribute('data-mock') === 'true';
  var L = window.INS_B2B_I18N || {};
  var EN = L.lang === 'en';
  var LOC = EN ? 'en-GB' : 'nl-NL';
  var fmt = new Intl.NumberFormat(EN ? 'en-IE' : 'nl-NL', { style: 'currency', currency: 'EUR' });
  var eur = function (n) { return fmt.format(Math.round(n * 100) / 100); };
  // Shopify's t filter HTML-escapes ' & " < >; decode once so JS text shows Extra's, not Extra&#39;s.
  var ENT = { '&#39;': "'", '&#x27;': "'", '&quot;': '"', '&lt;': '<', '&gt;': '>', '&amp;': '&' };
  var tr = function (k, m) { var s = String(L[k] || '').replace(/&#39;|&#x27;|&quot;|&lt;|&gt;|&amp;/g, function (e) { return ENT[e]; }); Object.keys(m || {}).forEach(function (x) { s = s.split('[' + x + ']').join(m[x]); }); return s; };
  var STORE_KEY = 'ins-b2b-draft';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var items = {};
  D.products.forEach(function (p) { items[p.id] = Object.assign({ qty: 0, tiered: true }, p); });
  D.extras.forEach(function (e) { items[e.id] = Object.assign({ qty: 0, tiered: false }, e); });
  var mode = 'order';
  var lastId = null;
  var expanded = false;
  var prevUnit = null;
  var shown = {};
  var sent = false;
  var frozen = false;

  /* Tier maths */
  function pieces() { return D.products.reduce(function (s, p) { return s + items[p.id].qty; }, 0); }
  function tierFor(n) {
    var t = null;
    D.tiers.forEach(function (x) { if (n >= x.from) t = x; });
    return t;
  }
  function nextTier(n) {
    for (var i = 0; i < D.tiers.length; i++) if (n < D.tiers[i].from) return D.tiers[i];
    return null;
  }
  function calc() {
    var n = pieces();
    var tier = tierFor(n);
    var unit = tier ? tier.price : D.tiers[0].price;
    var lines = [];
    var sub = 0;
    D.products.forEach(function (p) {
      var q = items[p.id].qty; if (!q) return;
      var amt = q * unit; sub += amt;
      lines.push({ id: p.id, line: p.line, short: p.name, name: p.lineName + ' ' + p.name, facts: p.facts, qty: q, unit: unit, amount: amt });
    });
    D.extras.forEach(function (e) {
      var q = items[e.id].qty; if (!q) return;
      var amt = q * e.price; sub += amt;
      lines.push({ id: e.id, line: '', short: e.name, name: e.name, qty: q, unit: e.price, amount: amt });
    });
    var vat = sub * D.vat / 100;
    var nxt = nextTier(n);
    var nudge = null;
    if (n > 0 && nxt) {
      var delta = nxt.from - n;
      var net = delta * nxt.price - (tier ? n * (unit - nxt.price) : 0);
      nudge = { delta: delta, price: nxt.price, net: net, from: nxt.from };
    }
    return { n: n, tier: tier, unit: unit, lines: lines, sub: sub, vat: vat, total: sub + vat, shipIncluded: true, nudge: nudge, ok: n >= D.minimum };
  }

  /* Delivery date: today plus N working days, weekends skipped */
  function deliveryDate() {
    var d = new Date(); var left = D.deliveryDays;
    while (left > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) left--; }
    return d.toLocaleDateString(EN ? 'en-GB' : 'nl-NL', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };

  /* Tier bar: equal segments per tier, the fill interpolates within the current segment */
  var marks = $('[data-tiermarks]');
  var T = D.tiers.length;
  D.tiers.forEach(function (t, i) {
    var s = document.createElement('span');
    s.textContent = eur(t.price).replace(/[.,]00$/, '');
    s.style.left = ((i + 1) / T * 100) + '%';
    s.setAttribute('data-from', t.from);
    marks.appendChild(s);
  });
  function fillPct(n) {
    var xs = [0].concat(D.tiers.map(function (t) { return t.from; }));
    var ys = [0].concat(D.tiers.map(function (t, i) { return (i + 1) / T * 100; }));
    if (n >= xs[xs.length - 1]) return 100;
    for (var i = 1; i < xs.length; i++) if (n < xs[i]) return ys[i - 1] + (n - xs[i - 1]) / (xs[i] - xs[i - 1]) * (ys[i] - ys[i - 1]);
    return 100;
  }

  /* The receipt's lines, grouped by world; compact shows the last line added */
  function renderLines(c) {
    var box = $('[data-lines]');
    var groups = [];
    c.lines.forEach(function (l) {
      var g = groups[groups.length - 1];
      if (!g || g.line !== l.line) { g = { line: l.line, rows: [] }; groups.push(g); }
      g.rows.push(l);
    });
    var focus = lastId && items[lastId] && items[lastId].qty ? lastId : (c.lines.length ? c.lines[c.lines.length - 1].id : null);
    var html = '';
    var now = {};
    groups.forEach(function (g) {
      var rows = expanded ? g.rows : g.rows.filter(function (l) { return l.id === focus; });
      if (!rows.length) return;
      var title = g.line ? '<i class="ins-b2b-dot"></i>' + esc(g.line.charAt(0).toUpperCase() + g.line.slice(1)) : esc(tr('r_loose'));
      html += '<div class="ins-b2b-rcpt__group ins-b2b-rcpt__group--' + (g.line || 'loose') + '"><span class="ins-b2b-rcpt__world">' + title + '</span>';
      rows.forEach(function (l) {
        now[l.id] = 1;
        html += '<div class="ins-b2b-rcpt__line' + (shown[l.id] || reduced ? '' : ' is-new') + '"><span class="ins-b2b-rcpt__q">' + l.qty + '</span><span class="ins-b2b-rcpt__n">' + esc(l.short) + '</span><span class="ins-b2b-rcpt__lead"></span><span class="ins-b2b-rcpt__a">' + eur(l.amount) + '</span></div>';
      });
      html += '</div>';
    });
    box.innerHTML = html;
    shown = {}; c.lines.forEach(function (l) { shown[l.id] = 1; });
    var tg = $('[data-rcpt-toggle]');
    tg.hidden = !c.lines.length;
    tg.textContent = expanded ? tr('r_show_less') : (c.lines.length === 1 ? tr('r_show_all_one') : tr('r_show_all', { n: c.lines.length }));
    tg.setAttribute('aria-expanded', expanded);
    $('[data-rcpt-details]').hidden = !expanded || !c.lines.length;
    var empty = $('[data-rcpt-empty]');
    empty.hidden = !!c.lines.length;
    empty.textContent = tr('r_empty', { n: D.minimum });
  }

  function render() {
    var c = calc();
    $$('[data-pieces]').forEach(function (el) { el.textContent = c.n; });
    $$('[data-total-input]').forEach(function (el) { if (document.activeElement !== el) el.value = c.n || ''; });
    $('[data-tierfill]').style.width = fillPct(c.n) + '%';
    $$('span', marks).forEach(function (m) { m.classList.toggle('is-on', c.n >= +m.getAttribute('data-from')); });
    $$('[data-tier-from]').forEach(function (r) { r.setAttribute('aria-checked', !!(c.tier && c.n > 0 && +r.getAttribute('data-tier-from') === c.tier.from)); });

    var unitLine = $('[data-unitline]');
    if (c.n === 0) unitLine.innerHTML = esc(tr('r_from_min', { min: D.minimum })) + ' <b>' + eur(D.tiers[0].price) + '</b> ' + esc(tr('per_piece_ex'));
    else if (!c.ok) unitLine.innerHTML = '<b>' + c.n + '</b> ' + esc(tr('pieces')) + ' <span>' + esc(tr('r_min_left', { n: D.minimum - c.n, min: D.minimum })) + '</span>';
    else unitLine.innerHTML = '<b>' + c.n + '</b> ' + esc(tr('pieces')) + ' <span>&middot;</span> <b>' + eur(c.unit) + '</b> ' + esc(tr('per_piece_ex'));

    var nudge = $('[data-nudge]');
    if (c.nudge && c.ok) {
      var g = c.nudge;
      var txt = esc(tr(g.delta === 1 ? 'nudge_more_one' : 'nudge_more', { n: g.delta, price: eur(g.price) })) + ' ';
      txt += g.net <= 0 ? esc(tr('nudge_lower', { amount: eur(-g.net) })) : esc(tr('nudge_net', { n: g.delta, amount: eur(g.net) }));
      nudge.innerHTML = txt; nudge.hidden = false;
    } else if (c.nudge && c.n > 0) {
      nudge.textContent = tr('nudge_min', { min: D.minimum }); nudge.hidden = false;
    } else nudge.hidden = true;

    renderLines(c);
    $('[data-sub]').textContent = eur(c.sub);
    $('[data-vat-label]').textContent = tr('vat', { n: D.vat });
    $('[data-vat-amount]').textContent = eur(c.vat);
    $('[data-total]').textContent = eur(c.total);
    $('[data-bar-total]').textContent = eur(c.total);
    $('[data-bar-unit]').textContent = c.ok ? '· ' + eur(c.unit) : tr('bar_min', { n: D.minimum });
    $('[data-delivery]').textContent = tr('delivery', { date: deliveryDate() });

    var crossed = prevUnit !== null && prevUnit !== c.unit;
    prevUnit = c.unit;
    $$('[data-unit-price]').forEach(function (el) {
      el.textContent = eur(c.unit);
      if (crossed && !reduced) { el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
    });
    $$('[data-item]').forEach(function (card) {
      var it = items[card.getAttribute('data-item')];
      card.classList.toggle('has-qty', it.qty > 0);
      var inp = $('[data-qty]', card); if (document.activeElement !== inp) inp.value = it.qty;
      $('[data-step="-1"]', card).disabled = it.qty <= 0;
      $('[data-step="1"]', card).disabled = it.qty >= it.avail;
      $$('[data-add]', card).forEach(function (b) { b.disabled = it.qty >= it.avail; });
      var av = $('[data-avail-text]', card);
      if (av) { av.textContent = it.qty >= it.avail ? tr('avail_all') : tr('avail', { n: it.avail - it.qty }); av.classList.toggle('is-low', it.avail <= 30); }
    });

    var orderOk = mode === 'sample' || c.ok;
    $$('[data-cta]').forEach(function (a) { a.classList.toggle('is-off', !orderOk); });
    $('[data-submit]').disabled = !orderOk;
    $('[data-min-msg]').hidden = orderOk;
    writeBody(c);
    fillSheet(c);
    save();
  }

  /* World stills follow the row in focus */
  function showStill(row) {
    var world = row && row.closest('[data-world]'); if (!world) return;
    var kind = row.getAttribute('data-kind');
    $$('.ins-b2b-world__still img', world).forEach(function (img) { img.classList.toggle('is-on', img.getAttribute('data-kind') === kind); });
  }

  function setQty(id, q) {
    var it = items[id]; if (!it) return;
    q = Math.max(0, Math.min(it.avail, Math.round(+q || 0)));
    it.qty = q;
    lastId = id;
    syncPerPiece();
    render();
  }
  function syncPerPiece() {
    D.extras.forEach(function (e) {
      if (!e.perPiece) return;
      var card = $('[data-item="' + e.id + '"]'); var t = card && $('[data-per-piece]', card);
      if (t && t.checked) items[e.id].qty = Math.min(e.avail, pieces());
    });
  }

  /* The first question: a total spread over the formats in play (all six when none are) */
  function inPlay() {
    var ids = D.products.filter(function (x) { return items[x.id].qty > 0; }).map(function (x) { return x.id; });
    return ids.length ? ids : D.products.map(function (x) { return x.id; });
  }
  function spread(total, ids) {
    ids = ids.filter(function (id) { return items[id].avail > 0; });
    if (!ids.length) return;
    total = Math.max(0, Math.round(+total || 0));
    ids.forEach(function (id) { items[id].qty = 0; });
    var left = total; var base = Math.floor(total / ids.length); var rem = total - base * ids.length;
    ids.forEach(function (id, i) { var q = base + (i < rem ? 1 : 0); items[id].qty = Math.min(items[id].avail, q); left -= items[id].qty; });
    var guard = 0;
    while (left > 0 && guard++ < 1000) {
      var moved = false;
      ids.forEach(function (id) { if (left > 0 && items[id].qty < items[id].avail) { items[id].qty++; left--; moved = true; } });
      if (!moved) break;
    }
    syncPerPiece(); render();
  }
  $$('[data-tier-from]').forEach(function (b) {
    b.addEventListener('click', function () { spread(+b.getAttribute('data-tier-from'), inPlay()); });
  });
  var spreadIds = null;
  $$('[data-total-input]').forEach(function (inp) {
    inp.addEventListener('focus', function () { spreadIds = inPlay(); });
    inp.addEventListener('input', function () { if (inp.value === '') return; spread(inp.value, spreadIds || inPlay()); });
    inp.addEventListener('change', function () { spreadIds = null; inp.value = pieces() || ''; });
    inp.addEventListener('blur', function () { spreadIds = null; inp.value = pieces() || ''; });
  });

  /* Steppers, inputs, +25/+50/+100 (they add), toggles */
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (step) { var card = step.closest('[data-item]'); var id = card.getAttribute('data-item'); setQty(id, items[id].qty + (+step.getAttribute('data-step'))); showStill(card); return; }
    var add = e.target.closest('[data-add]');
    if (add) { var row = add.closest('[data-item]'); var aid = row.getAttribute('data-item'); setQty(aid, items[aid].qty + (+add.getAttribute('data-add'))); showStill(row); return; }
    if (e.target.closest('[data-rcpt-toggle]')) { expanded = !expanded; render(); }
  });
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-qty]')) { var card = e.target.closest('[data-item]'); setQty(card.getAttribute('data-item'), e.target.value); }
    if (e.target.matches('[data-company], [data-person], [data-week], [data-sample-only] input')) { writeBody(calc()); fillSheet(); save(); }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty]')) { e.target.value = items[e.target.closest('[data-item]').getAttribute('data-item')].qty; }
    if (e.target.matches('[data-per-piece]')) { var id = e.target.closest('[data-item]').getAttribute('data-item'); if (!e.target.checked) items[id].qty = 0; lastId = id; syncPerPiece(); render(); }
  });
  root.addEventListener('focusin', function (e) { var row = e.target.closest('.ins-b2b-row'); if (row) showStill(row); });
  root.addEventListener('mouseover', function (e) { var row = e.target.closest('.ins-b2b-row'); if (row) showStill(row); });

  /* Mode: order or sample */
  function setMode(m) {
    mode = m;
    $$('[data-mode]').forEach(function (b) { var on = b.getAttribute('data-mode') === m; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
    $$('[data-order-only]').forEach(function (el) { el.hidden = m === 'sample'; $$('input, select', el).forEach(function (i) { i.disabled = m === 'sample'; }); });
    $$('[data-sample-only]').forEach(function (el) { el.hidden = m !== 'sample'; $$('input', el).forEach(function (i) { i.disabled = m !== 'sample'; }); });
    $('[data-next-order]').hidden = m === 'sample';
    $('[data-next-sample]').hidden = m !== 'sample';
    var ft = $('[data-field-type]'); ft.value = ft.getAttribute(m === 'sample' ? 'data-type-sample' : 'data-type-order');
    $('[data-submit]').textContent = tr(m === 'sample' ? 'mode_sample' : 'mode_order');
    render();
  }
  $$('[data-mode]').forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-mode')); }); });
  $$('[data-mode-link]').forEach(function (a) { a.addEventListener('click', function () {
    $$('[data-sample-only] input[type="checkbox"]').forEach(function (i) { i.checked = true; });
    setMode(a.getAttribute('data-mode-link'));
  }); });

  /* Btw-nummer: format check and country note */
  var vatIn = $('[data-vat]'); var vatNote = $('[data-vat-note]'); var kvk = $('[data-kvk]');
  if (vatIn) vatIn.addEventListener('input', function () {
    var v = vatIn.value.replace(/[\s.]/g, '').toUpperCase(); vatIn.value = v;
    if (!v) { vatNote.textContent = tr('vat_hint'); vatNote.className = ''; return; }
    if (/^NL[0-9]{9}B[0-9]{2}$/.test(v)) { vatNote.textContent = tr('vat_nl'); vatNote.className = ''; }
    else if (/^BE0[0-9]{9}$/.test(v)) { vatNote.textContent = tr('vat_be'); vatNote.className = ''; }
    else { vatNote.textContent = tr('vat_bad'); vatNote.className = 'is-bad'; }
  });
  if (kvk) kvk.addEventListener('input', function () { kvk.value = kvk.value.replace(/\D/g, '').slice(0, 8); });

  /* The mail body: order lines and totals as one readable block, in the page's language */
  function bodyText(c) {
    var out = [];
    if (mode === 'sample') {
      var picks = $$('[data-sample-only] input:checked').map(function (i) { return i.value; });
      return [tr('mail_sample_head'), tr('mail_picked', { list: picks.join(', ') || tr('mail_none') })].join('\n');
    }
    out.push(tr('mail_head'));
    out.push(tr('mail_count', { n: c.n }) + (c.tier ? tr('mail_unit', { price: eur(c.unit) }) : ''));
    out.push('');
    c.lines.forEach(function (l) { out.push(tr('mail_line', { q: l.qty, name: l.name, unit: eur(l.unit), amount: eur(l.amount) })); });
    out.push('');
    out.push(tr('mail_sub', { amount: eur(c.sub) }));
    out.push(tr('mail_ship', { text: tr('mail_ship_incl') }));
    out.push(tr('mail_vat', { n: D.vat, amount: eur(c.vat) }));
    out.push(tr('mail_total', { amount: eur(c.total) }));
    out.push('');
    out.push(tr('mail_terms', { days: D.deliveryDays, payment: D.paymentTerms }));
    out.push(tr('mail_link', { url: shareUrl() }));
    return out.join('\n');
  }
  function writeBody(c) { $('[data-field-body]').value = bodyText(c); }

  /* Share link: quantities in the URL */
  function shareUrl() {
    var parts = []; Object.keys(items).forEach(function (id) { if (items[id].qty) parts.push(id + ':' + items[id].qty); });
    var u = new URL(location.href); u.hash = ''; u.searchParams.delete('q');
    if (parts.length) u.searchParams.set('q', parts.join(','));
    return u.toString();
  }
  $('[data-share]').addEventListener('click', function () {
    var url = shareUrl(); history.replaceState(null, '', url);
    var done = function () { $('[data-shared]').hidden = false; setTimeout(function () { $('[data-shared]').hidden = true; }, 4000); };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
  });
  /* The filled sheet (confirmation and print view): "Overzicht voor" until requested, then "Aanvraag van" with the stamp */
  var val = function (sel) { var el = $(sel); return el && el.value ? el.value.trim() : ''; };
  function today() { return new Date().toLocaleDateString(LOC, { day: 'numeric', month: 'long', year: 'numeric' }); }
  function fillSheet(c, who) {
    var sh = $('[data-sheet]'); if (!sh || frozen) return;
    c = c || calc(); who = who || { co: val('[data-company]'), pe: val('[data-person]') };
    sh.setAttribute('data-state', sent ? 'sent' : 'draft');
    sh.setAttribute('data-sheet-mode', mode);
    var fr = $('[data-sheet-for]', sh); fr.textContent = who.co ? fr.getAttribute(sent ? 'data-sent' : 'data-draft') : '';
    var h = $('[data-sheet-company]', sh); h.textContent = who.co || h.getAttribute('data-blank');
    var meta = esc([who.pe, today()].filter(Boolean).join(' \u00b7 '));
    var wk = $('[data-week]');
    if (mode === 'order' && wk && wk.value) meta += '<br>' + esc(tr('f_week') + ': ' + wk.options[wk.selectedIndex].text);
    $('[data-sheet-meta]', sh).innerHTML = meta;
    $('[data-sheet-stamp-date]', sh).textContent = today();
    var rows = c.lines;
    if (mode === 'sample') rows = $$('[data-sample-only] input:checked').map(function (i) { return { qty: 1, line: i.value.split(' ')[0].toLowerCase(), short: i.parentNode.textContent.trim() }; });
    $$('[data-sheet-group]', sh).forEach(function (g) {
      var key = g.getAttribute('data-sheet-group');
      var mine = rows.filter(function (l) { return (l.line || '') === key; });
      g.hidden = !mine.length;
      $('[data-sheet-rows]', g).innerHTML = mine.map(function (l) {
        return '<div class="ins-b2b-sheet__row"><span>' + l.qty + '</span><span>' + esc(l.short) + (l.facts ? '<small>' + esc(l.facts) + '</small>' : '') + '</span><span>' + (l.unit != null ? eur(l.unit) : '') + '</span><span>' + (l.amount != null ? eur(l.amount) : '') + '</span></div>';
      }).join('');
    });
    $$('[data-sheet-tier]', sh).forEach(function (li) { li.classList.toggle('is-on', !!(c.tier && c.n > 0 && +li.getAttribute('data-sheet-tier') === c.tier.from)); });
    $('[data-sheet-unit]', sh).textContent = c.ok ? tr('sheet_unit', { n: c.n, price: eur(c.unit) }) : c.n + ' ' + tr('pieces') + ', ' + tr('r_min_left', { n: D.minimum - c.n, min: D.minimum });
    $('[data-sheet-sub]', sh).textContent = eur(c.sub);
    $('[data-sheet-vat-label]', sh).textContent = tr('vat', { n: D.vat });
    $('[data-sheet-vat]', sh).textContent = eur(c.vat);
    $('[data-sheet-total]', sh).textContent = eur(c.total);
    $('[data-sheet-delivery]', sh).textContent = tr('delivery', { date: deliveryDate() });
  }
  $$('[data-print]').forEach(function (b) { b.addEventListener('click', function () { fillSheet(); window.print(); }); });
  window.addEventListener('beforeprint', function () { fillSheet(); });

  /* Leverweek: the next eight weeks, each with its Monday */
  function isoWeek(d) { var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())); var w = t.getUTCDay() || 7; t.setUTCDate(t.getUTCDate() + 4 - w); return Math.ceil(((t - new Date(Date.UTC(t.getUTCFullYear(), 0, 1))) / 86400000 + 1) / 7); }
  var weekSel = $('[data-week]');
  if (weekSel) {
    var mon = new Date(); mon.setHours(12, 0, 0, 0); mon.setDate(mon.getDate() + ((8 - mon.getDay()) % 7 || 7));
    for (var wi = 0; wi < 8; wi++) {
      var wd = new Date(mon); wd.setDate(mon.getDate() + 7 * wi);
      var o = document.createElement('option');
      o.textContent = tr('week_option', { n: isoWeek(wd), date: wd.toLocaleDateString(LOC, { day: 'numeric', month: 'long' }) });
      o.value = o.textContent + ' ' + wd.getFullYear();
      weekSel.appendChild(o);
    }
  }

  /* Persist and restore */
  function save() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ q: Object.keys(items).reduce(function (o, id) { if (items[id].qty) o[id] = items[id].qty; return o; }, {}), mode: mode, body: $('[data-field-body]').value, co: val('[data-company]'), pe: val('[data-person]') })); } catch (e) {}
  }
  function restore() {
    var q = new URL(location.href).searchParams.get('q');
    if (q) { q.split(',').forEach(function (p) { var kv = p.split(':'); if (items[kv[0]]) items[kv[0]].qty = Math.min(items[kv[0]].avail, +kv[1] || 0); }); return; }
    try { var s = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); if (s && s.q) Object.keys(s.q).forEach(function (id) { if (items[id]) items[id].qty = Math.min(items[id].avail, s.q[id]); }); } catch (e) {}
  }

  /* Mobile sheet */
  var sheet = $('[data-summary]');
  var sheetOpen = function (on) { sheet.classList.toggle('is-open', on); document.documentElement.classList.toggle('ins-b2b-sheet-open', on); };
  $('[data-sheet-open]').addEventListener('click', function () { sheetOpen(true); });
  $('[data-sheet-close]').addEventListener('click', function () { sheetOpen(false); });
  $$('[data-cta]').forEach(function (a) { a.addEventListener('click', function () { sheetOpen(false); }); });
  var bar = $('[data-bar]');
  var setBarH = function () { if (bar.offsetHeight) document.documentElement.style.setProperty('--ins-b2b-bar-h', bar.offsetHeight + 'px'); };
  setBarH(); window.addEventListener('resize', setBarH);

  /* Submit. Mock mode: the button is type=button, so no submit event and nothing posts; the payload is shown instead.
     Live mode: the native post goes through (Shopify's captcha script may submit the form itself, so nothing here is relied on). */
  var form = document.getElementById('B2BForm');
  function showMock() {
    var c = calc(); writeBody(c);
    var fd = new FormData(form); var table = $('[data-payload-table]'); table.innerHTML = '';
    var seen = {};
    fd.forEach(function (v, k) {
      var key = k + (seen[k] ? ' (' + (++seen[k]) + ')' : ''); seen[k] = seen[k] || 1;
      var tr2 = document.createElement('tr'); tr2.innerHTML = '<td></td><td></td>';
      tr2.children[0].textContent = key; tr2.children[1].textContent = String(v); table.appendChild(tr2);
    });
    var body = $('[data-field-body]').value;
    sent = true; fillSheet(c);
    var subj = tr(mode === 'sample' ? 'mail_subject_sample' : 'mail_subject');
    $('[data-mailto]').href = 'mailto:' + encodeURIComponent(($('[data-email]') || {}).value || '') + '?subject=' + encodeURIComponent(subj) + '&body=' + encodeURIComponent(body);
    form.hidden = true; $('[data-confirm]').hidden = false;
    $('[data-confirm]').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  $('[data-submit]').addEventListener('click', function (e) {
    if (!MOCK) return;
    e.preventDefault();
    if (mode === 'order' && !calc().ok) { $('[data-min-msg]').hidden = false; return; }
    if (!form.reportValidity()) return;
    showMock();
  });

  /* Beside the form the rail button sends, through the form's own button, so there is one send path */
  var formBand = $('#gegevens'), railCta = $('.ins-b2b-rcpt__cta'), atForm = false;
  if (formBand && railCta && 'IntersectionObserver' in window) {
    var ctaLabel = railCta.textContent;
    var syncCta = function () { railCta.textContent = atForm ? $('[data-submit]').textContent : ctaLabel; };
    new IntersectionObserver(function (es) { atForm = es[0].isIntersecting; syncCta(); }, { rootMargin: '0px 0px -40% 0px' }).observe(formBand);
    $$('[data-mode]').forEach(function (b) { b.addEventListener('click', syncCta); });
    railCta.addEventListener('click', function (e) { if (!atForm) return; e.preventDefault(); $('[data-submit]').click(); });
  }
  form.addEventListener('submit', function (e) {
    var c = calc();
    if (MOCK || (mode === 'order' && !c.ok)) { e.preventDefault(); $('[data-min-msg]').hidden = c.ok; if (MOCK && c.ok && form.reportValidity()) showMock(); return; }
    writeBody(c);
  });
  $('[data-confirm-close]').addEventListener('click', function () { sent = false; fillSheet(); form.hidden = false; $('[data-confirm]').hidden = true; });

  /* After a real post: the filled sheet, stamped, from the draft saved before the post */
  var success = $('[data-success]');
  if (success) {
    /* After a send the page ends on the thank-you card and its sheet: the overview, the bar, the mode tabs and the emptied fields go */
    $$('[data-summary], [data-bar], .ins-b2b-mode, [data-next-sample], #B2BForm > :not([data-success])').forEach(function (el) { el.style.display = 'none'; });
    document.documentElement.style.setProperty('--ins-b2b-bar-h', '0px');
    try {
    var d = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
    if (d && d.q) { Object.keys(d.q).forEach(function (id) { if (items[id]) items[id].qty = d.q[id]; }); mode = d.mode || 'order'; sent = true; fillSheet(calc(), { co: d.co || '', pe: d.pe || '' }); success.appendChild($('[data-sheet]')); frozen = true; }
    localStorage.removeItem(STORE_KEY); Object.keys(items).forEach(function (id) { items[id].qty = 0; });
  } catch (e) {} }

  restore();
  syncPerPiece();
  setMode('order');
  if (success) success.scrollIntoView({ block: 'start' });
  window.INS_B2B = { calc: calc, setQty: setQty, items: items, setMode: setMode, spread: spread, inPlay: inPlay };
})();
